<template>
  <div>
    <BackLink class="mt-4 mb-2" :to="{ name: 'tickets' }" data-testid="invite-back-link">{{ t('backToOverview') }}</BackLink>

    <ContentCard>
      <template #header>
        <EventItem :event="props.event" :show-main-button="false" :show-chip="false" :show-dropdown="false" />
      </template>

      <template v-if="invitationQuotas.length">
        <template v-if="showGroupedQuotas">
          <div v-if="personalQuotas.length" data-testid="invite-personal-quotas">
            <h2 class="py-4 text-headline-m">{{ t('Dashboard.quotas.title') }}</h2>
            <div v-for="quota in personalQuotas" :key="quota.id" :quota="quota" class="separate-rows">
              <InviteQuotaItem :quota="quota" />
            </div>
          </div>

          <div v-if="partnerCompanyQuotas.length" class="pt-8" data-testid="invite-partner-quotas">
            <h2 v-if="partnerCompanyTitle" class="pb-4 text-headline-m">{{ partnerCompanyTitle }}</h2>
            <div v-for="quota in partnerCompanyQuotas" :key="quota.id" :quota="quota" class="separate-rows">
              <InviteQuotaItem :quota="quota" />
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="quota in invitationQuotas" :key="quota.id" :quota="quota" class="separate-rows">
            <InviteQuotaItem :quota="quota" />
          </div>
        </template>
      </template>
      <div v-else class="py-4" data-testid="invite-no-quotas">
        {{ t('InvitationQuota.noQuotas') }}
      </div>
    </ContentCard>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { EventQuery } from '@/gql/myomr'
import { groupInvitationQuotas } from '@/helpers/groupInvitationQuotas'
import { filterSupportedInvitationQuotas } from '@/helpers/invitationQuotas'
import { useMeStore } from '@/stores'
import BackLink from '@/ui/BackLink.vue'

import { default as EventItem } from './EventItem.vue'
import { default as InviteQuotaItem } from './InviteQuotaItem.vue'

const { t } = useI18n()
const meStore = useMeStore()

const props = defineProps<{
  event: EventQuery['eventById']
}>()

const invitationQuotas = computed(() => filterSupportedInvitationQuotas(props.event.invitationQuotas || []))

const groupedQuotas = computed(() => groupInvitationQuotas(invitationQuotas.value))
const personalQuotas = computed(() => groupedQuotas.value.personalQuotas)
const partnerCompanyQuotas = computed(() => groupedQuotas.value.partnerCompanyQuotas)

const showGroupedQuotas = computed(() => {
  return personalQuotas.value.length > 0 && partnerCompanyQuotas.value.length > 0
})

const partnerCompanyTitle = computed(() => {
  return meStore.me?.partnerCompany?.displayName || meStore.me?.partnerCompany?.name || ''
})
</script>
